/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionsSummary } from './TransactionsSummary';
import {
    TransactionsSummaryFromJSON,
    TransactionsSummaryFromJSONTyped,
    TransactionsSummaryToJSON,
    TransactionsSummaryToJSONTyped,
} from './TransactionsSummary';
import type { WalletTransactionItem } from './WalletTransactionItem';
import {
    WalletTransactionItemFromJSON,
    WalletTransactionItemFromJSONTyped,
    WalletTransactionItemToJSON,
    WalletTransactionItemToJSONTyped,
} from './WalletTransactionItem';

/**
 * List of tournament transactions
 * @export
 * @interface TransactionsListResponse
 */
export interface TransactionsListResponse {
    /**
     * 
     * @type {Array<WalletTransactionItem>}
     * @memberof TransactionsListResponse
     */
    transactions: Array<WalletTransactionItem>;
    /**
     * 
     * @type {number}
     * @memberof TransactionsListResponse
     */
    total: number;
    /**
     * 
     * @type {TransactionsSummary}
     * @memberof TransactionsListResponse
     */
    summary: TransactionsSummary;
}

/**
 * Check if a given object implements the TransactionsListResponse interface.
 */
export function instanceOfTransactionsListResponse(value: object): value is TransactionsListResponse {
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function TransactionsListResponseFromJSON(json: any): TransactionsListResponse {
    return TransactionsListResponseFromJSONTyped(json, false);
}

export function TransactionsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(WalletTransactionItemFromJSON)),
        'total': json['total'],
        'summary': TransactionsSummaryFromJSON(json['summary']),
    };
}

export function TransactionsListResponseToJSON(json: any): TransactionsListResponse {
    return TransactionsListResponseToJSONTyped(json, false);
}

export function TransactionsListResponseToJSONTyped(value?: TransactionsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': ((value['transactions'] as Array<any>).map(WalletTransactionItemToJSON)),
        'total': value['total'],
        'summary': TransactionsSummaryToJSON(value['summary']),
    };
}

